<template lang="pug">
  Popup(
    :visible="visible"
    position="bottom"
    :maskClosable="true"
    @close="handlePopupClose"
  )
    .task-popup-container
      .task-popup-header
        .header-title 做任务赚奖励金
        .header-desc 攒够奖励金，免费骑车
        img.close-icon(
          src="https://m.hellobike.com/resource/gallery/833/_S52l7ryep.png"
          alt=""
          @click="handlePopupClose"
        )
      .task-popup-body
        .task-info-panel
          .task-info-panel-content
            .task-info-title {{ taskInfo.taskName }}
            .task-info-desc
              span 再得
              span.num {{ taskInfo.offerWorth }}
              span 奖励金
        .task-popup-btns
          .cancel-btn.btn(
            v-if="taskInfo.taskStatus !== TASK_STATUS.FINISHED"
            @click="handlePopupClose"
          ) 暂时不做
          .do-task-btn.btn(
            :class="{ 'task-done': taskInfo.taskStatus === TASK_STATUS.FINISHED }"
            @click="handleBtnClick"
          ) {{ taskInfo.popupBtnName }}
</template>

<script>
import { debounce } from '@/utils';
import Popup from '@/components/popup';
import { TASK_STATUS_V2 } from '@/const/task';
import SPM from '../common/spm';
import { handleTaskBtnClick } from '../common/task';

export default {
  name: 'TaskPopup',
  components: { Popup },
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 任务信息
    taskInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 任务状态
      TASK_STATUS: TASK_STATUS_V2,
      // 任务跳转倒计时
      jumpTimer: null,
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 任务弹窗曝光
        SPM.moduleExpose({
          moduleId: 'Welfare_taskpop',
          contentId: 'Welfare_taskpop',
          businessInfo: {
            task_id: this.taskInfo.taskCode,
          },
        });
      }
    },
  },
  mounted() {
    this.clearTimeout();
  },
  beforeDestroy() {
    this.jumpTimer = null;
  },
  methods: {
    // 清除倒计时
    clearTimeout() {
      const clearTimeout = () => {
        if (this.jumpTimer) {
          clearTimeout(this.jumpTimer);
        }
      };
      document.addEventListener('visibilitychange', () => {
        if (document.hidden || document.webkitHidden) {
          clearTimeout();
        }
      });
      window.addEventListener('pagehide', () => {
        clearTimeout();
      });
    },
    // 弹层关闭
    handlePopupClose() {
      this.$emit('close');
      SPM.clickButton({
        buttonName: 'Welfare_taskpop_close',
        businessInfo: {
          task_id: this.taskInfo.taskCode,
        },
      });
    },
    // 按钮点击
    handleBtnClick: debounce(async function exec() {
      const options = {
        scene: 'task_popup',
      };
      const { closePopup, info } = await handleTaskBtnClick.call(
        this,
        this.taskInfo,
        options,
      );
      this.$emit('btnClick', { closePopup, info });
    }, 300),
  },
};
</script>

<style lang="less" scoped>
.task-popup-container {
  .task-popup-header {
    position: relative;
    padding: 0.14rem 0 0 0.2rem;
    margin-bottom: -0.02rem;
    width: 100%;
    height: 0.82rem;
    background-image: url('https://m.hellobike.com/resource/gallery/833/VjMfUmn6_Frame%201707483017.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;

    .header-title {
      font-weight: 600;
      font-size: 0.2rem;
      line-height: 0.28rem;
      color: #242729;
    }

    .header-desc {
      margin-top: 0.04rem;
      font-size: 0.12rem;
      line-height: 0.17rem;
      color: #5a6066;
    }

    .close-icon {
      position: absolute;
      top: -0.02rem;
      right: 0.09rem;
      width: 0.16rem;
      height: 0.16rem;
      vertical-align: bottom;
    }
  }

  .task-popup-body {
    padding: 0.1rem 0.16rem 0;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 0.12rem);
    padding-bottom: calc(env(safe-area-inset-bottom) + 0.12rem);
    background-color: #fff;

    .task-info-panel {
      position: relative;
    }

    .task-info-panel::before {
      position: absolute;
      content: '';
      top: -0.04rem;
      left: -0.025rem;
      width: calc(100% + 0.05rem);
      height: 0.08rem;
      background: linear-gradient(90deg, #c56000 0%, #ffb671 100%);
      border-radius: 0.035rem;
    }

    .task-info-panel-content {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 0.08rem;
      height: 0.96rem;
      background: linear-gradient(
        180deg,
        #ffce63 0%,
        #fff2d5 6.73%,
        #fff4dd 80.29%,
        #fff0d0 90.14%,
        #ffe5ad 100%
      );
      border-radius: 0 0 0.09rem 0.09rem;
    }

    .task-info-title {
      font-weight: 600;
      font-size: 0.2rem;
      line-height: 0.28rem;
      color: #242729;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }

    .task-info-desc {
      display: flex;
      align-items: center;
      margin-top: 0.02rem;
      font-size: 0.16rem;
      line-height: 0.22rem;

      .num {
        color: #ff5c0a;
      }
    }
  }

  .task-popup-btns {
    margin-top: 0.2rem;
    display: flex;

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.48rem;
      border-radius: 0.12rem;
      box-sizing: border-box;
      font-weight: 500;
      font-size: 0.16rem;
      line-height: normal;
    }

    .cancel-btn {
      flex-shrink: 0;
      margin-right: 0.11rem;
      width: 1.32rem;
      border: 0.01rem solid #f50;
      color: #ff5c0a;
    }

    .do-task-btn {
      flex: 1;
      background-color: #ff5c0a;
      color: #fff;
    }

    .task-done {
      background-color: #ffd764;
      color: #643b00;
    }
  }
}
</style>
